import { ModifierDto } from '@symphony-solo/domain/modifiers/src';
import { PriceLevelDto } from '@symphony-solo/domain/price-levels/src';

export class TransactionUnitPriceDto {
  public modifier: ModifierDto;
  public priceLevel: PriceLevelDto;
  public portionSize: number;
  public originalPrice: number;
}
